//--computer styles ideas:
//sneaky pete: never pull from discard pile
//mal melon: hold on to card it know the oppoenent needs
//lucky 7: alway draw and hold on to 7s
//impossible: track oppnenets cards and guess he has matches to them
//todo: track actions from activity log and use that to make decisions
export const AIRuleSets = {
    Human: {
        preGame: [],
        deal: [],
        firstCard: [],
        mustTakeTop: [],
        draw: [],
        discard: [],
        knock: [],
        layoff: [],
        undercut: [],
        scoring: [],
        gameOver: [],
    },
    Easy: {
        preGame: [],
        deal: [],
        firstCard: [
            'TakeDiscardIfStartsRunInDeadwood',
            'Pass',
        ],
        mustTakeTop: [
            'TakeTopDraw',
        ],
        draw: [
            'TakeDiscardIfStartsRunInDeadwood',
            'TakeTopDraw',
            'TakeDiscardOrTakeTopRandom',
        ],
        discard: [
            'KnockIfCan',
            'DiscardHighestDeadwoodWhichIsNotARunOf2',
            'DiscardHighestDeadwood',
            'DiscardARandomCard',
        ],
        knock: [],
        layoff: [],
        undercut: [],
        scoring: [],
        gameOver: [],
    },
    Medium: {
        preGame: [],
        deal: [],
        firstCard: [
            'TakeDiscardIfMakesPairInDeadwood',
            'Pass',
        ],
        mustTakeTop: [
            'TakeTopDraw',
        ],
        draw: [
            'TakeDiscardIf5',
            'TakeDiscardIfMakesPairInDeadwood',
            'TakeTopDraw',
            'TakeDiscardOrTakeTopRandom',
        ],
        discard: [
            'KnockIfCan',
            'DiscardHighestDeadwoodWhichIsNotAPair',
            'DiscardHighestDeadwood',
            'DiscardARandomCard',
        ],
        knock: [],
        layoff: [],
        undercut: [],
        scoring: [],
        gameOver: [],
    },
    Hard: {
        preGame: [],
        deal: [],
        firstCard: [
            'TakeDiscardIfLowerDeadwoodCardCount',
            'TakeDiscardIfLowerDeadwoodScoreByOver5LessThan4CardsLeftInDeadWood',
            'TakeDiscardIfMakesPairInDeadwoodExecptIfOneOfSameRankIsHiddenInTheDiscardPile',
            'TakeDiscardIfStartsRunInDeadwoodExecptIfOneSideOfRunHiddenInTheDiscardPile',
            'TakeDiscardIfMakesPairInDeadwoodExecptIfTwoOfSameRankIsHiddenInTheDiscardPile',
            'TakeDiscardIfStartsRunInDeadwoodExecptIfTwoSideOfRunHiddenInTheDiscardPile',
            'Pass',
        ],
        mustTakeTop: [
            'TakeTopDraw',
        ],
        draw: [
            'TakeDiscardIfLowerDeadwoodCardCount',
            'TakeDiscardIfLowerDeadwoodScoreByOver5LessThan4CardsLeftInDeadWood',
            'TakeDiscardIfMakesPairInDeadwoodExecptIfOneOfSameRankIsHiddenInTheDiscardPile',
            'TakeDiscardIfStartsRunInDeadwoodExecptIfOneSideOfRunHiddenInTheDiscardPile',
            'TakeDiscardIfMakesPairInDeadwoodExecptIfTwoOfSameRankIsHiddenInTheDiscardPile',
            'TakeDiscardIfStartsRunInDeadwoodExecptIfTwoSideOfRunHiddenInTheDiscardPile',
            'TakeTopDraw',
        ],
        discard: [
            'KnockAnyDeadwoodIfEarlyGame',
            'KnockBelow8DeadwoodIfMidGame',
            'KnockBelow5DeadwoodIfLateGame',
            'KnockIfGin',
            'DiscardHighestDeadwoodWhichTwoOfSameRankForPairAreHiddenInDiscardPile',
            'DiscardHighestDeadwoodWhichTwoOnBothSidesForRunAreHiddenInDiscardPile',
            'DiscardHighestDeadwoodIfLessThan4CardsLeftInDeadWood',
            'DiscardHighestDeadwoodWhichIsNotAPairOrIsNotARunOf2AndHasAMatchingRankInTheDiscardPile',
            'DiscardHighestDeadwoodWhichIsNotAPairOrIsNotARunOf2',
            'DiscardLowestPairEarlyInTheGame',
            'DiscardHighestPair',
            'DiscardHighestDeadwood',
            'DiscardARandomCard',
        ],
        knock: [],
        layoff: [],
        undercut: [],
        scoring: [],
        gameOver: [],
    },
    CrazyNinja: {
        preGame: [],
        deal: [],
        firstCard: [
            'TakeDiscardIfLowerDeadwoodCardCount',
            'TakeDiscardIfLowerDeadwoodScoreByOver5LessThan4CardsLeftInDeadWood',
            'TakeDiscardIfMakesPairInDeadwoodExecptIfOneOfSameRankIsHiddenInTheDiscardPile',
            'TakeDiscardIfStartsRunInDeadwoodExecptIfOneSideOfRunHiddenInTheDiscardPile',
            'TakeDiscardIfMakesPairInDeadwoodExecptIfTwoOfSameRankIsHiddenInTheDiscardPile',
            'TakeDiscardIfStartsRunInDeadwoodExecptIfTwoSideOfRunHiddenInTheDiscardPile',
            'Pass',
        ],
        mustTakeTop: [
            'TakeTopDraw',
        ],
        draw: [
            'TakeDiscardIfLowerDeadwoodCardCount',
            'TakeDiscardIfLowerDeadwoodScoreByOver5LessThan4CardsLeftInDeadWood',
            'TakeDiscardIfMakesPairInDeadwoodExecptIfOneOfSameRankIsHiddenInTheDiscardPile',
            'TakeDiscardIfStartsRunInDeadwoodExecptIfOneSideOfRunHiddenInTheDiscardPile',
            'TakeDiscardIfMakesPairInDeadwoodExecptIfTwoOfSameRankIsHiddenInTheDiscardPile',
            'TakeDiscardIfStartsRunInDeadwoodExecptIfTwoSideOfRunHiddenInTheDiscardPile',
            'TakeTopDraw',
        ],
        discard: [
            'KnockAnyDeadwoodIfEarlyGame',
            'KnockBelow8DeadwoodIfMidGame',
            'KnockBelow5DeadwoodIfLateGame',
            'KnockIfGin',
            'DiscardHighestDeadwoodWhichTwoOfSameRankForPairAreHiddenInDiscardPile',
            'DiscardHighestDeadwoodWhichTwoOnBothSidesForRunAreHiddenInDiscardPile',
            'DiscardHighestDeadwoodIfLessThan4CardsLeftInDeadWood',
            'DiscardHighestDeadwoodWhichIsNotAPairOrIsNotARunOf2AndHasAMatchingRankInTheDiscardPile',
            'DiscardHighestDeadwoodWhichIsNotAPairOrIsNotARunOf2',
            'DiscardLowestPairEarlyInTheGame',
            'DiscardHighestPair',
            'DiscardHighestDeadwood',
            'DiscardARandomCard',
        ],
        knock: [],
        layoff: [],
        undercut: [],
        scoring: [],
        gameOver: [],
    },
    Test: {
        preGame: [],
        deal: [],
        firstCard: [
            'TakeDiscardIfLowerDeadwoodCardCount',
            'TakeDiscardIfLowerDeadwoodScoreByOver5LessThan4CardsLeftInDeadWood',
            'TakeDiscardIfMakesPairInDeadwoodExecptIfOneOfSameRankIsHiddenInTheDiscardPile',
            'TakeDiscardIfStartsRunInDeadwoodExecptIfOneSideOfRunHiddenInTheDiscardPile',
            'TakeDiscardIfMakesPairInDeadwoodExecptIfTwoOfSameRankIsHiddenInTheDiscardPile',
            'TakeDiscardIfStartsRunInDeadwoodExecptIfTwoSideOfRunHiddenInTheDiscardPile',
            'Pass',
        ],
        mustTakeTop: [
            'TakeTopDraw',
        ],
        draw: [
            'TakeDiscardIfLowerDeadwoodCardCount',
            'TakeDiscardIfLowerDeadwoodScoreByOver5LessThan4CardsLeftInDeadWood',
            'TakeDiscardIfMakesPairInDeadwoodExecptIfOneOfSameRankIsHiddenInTheDiscardPile',
            'TakeDiscardIfStartsRunInDeadwoodExecptIfOneSideOfRunHiddenInTheDiscardPile',
            'TakeDiscardIfMakesPairInDeadwoodExecptIfTwoOfSameRankIsHiddenInTheDiscardPile',
            'TakeDiscardIfStartsRunInDeadwoodExecptIfTwoSideOfRunHiddenInTheDiscardPile',
            'TakeTopDraw',
        ],
        discard: [
            'KnockAnyDeadwoodIfEarlyGame',
            'KnockBelow8DeadwoodIfMidGame',
            'KnockBelow5DeadwoodIfLateGame',
            'KnockIfGin',
            'DiscardHighestDeadwoodWhichTwoOfSameRankForPairAreHiddenInDiscardPile',
            'DiscardHighestDeadwoodWhichTwoOnBothSidesForRunAreHiddenInDiscardPile',
            'DiscardHighestDeadwoodIfLessThan4CardsLeftInDeadWood',
            'DiscardHighestDeadwoodWhichIsNotAPairOrIsNotARunOf2AndHasAMatchingRankInTheDiscardPile',
            'DiscardHighestDeadwoodWhichIsNotAPairOrIsNotARunOf2',
            'DiscardLowestPairEarlyInTheGame',
            'DiscardHighestPair',
            'DiscardHighestDeadwood',
            'DiscardARandomCard',
        ],
        knock: ['NextAction'],
        layoff: ['NextAction'],
        undercut: ['NextAction'],
        scoring: ['NextAction'],
        gameOver: ['NextAction'],
    },
};
//# sourceMappingURL=data:application/json;base64,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